import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card } from 'reactstrap';
import { Icon, Content } from '@myie/interact-dom';

class TravelInsuranceAdvert1 extends React.Component {
  constructor() {
    super();

    // Define the initial state:
    this.state = {
      testdata: '',
    };
  }

  render() {
    return (
      <Card className="advert travel-insurance-advert">
        <h2>
          <Content
            id="TravelAdvert1:Advert.title"
            copytext="Travel Insurance"
          />
        </h2>
        <Row>
          <Col xs={7}>
            <p>
              <Content
                id="TravelAdvert1:Advert.paragraph1"
                copytext="Worldwide travel insurance for you and your family. Including
              winter sports, gold and business"
              />
            </p>
          </Col>
          <Col xs={5}>
            <Icon name="TravelInsuranceAd" />
          </Col>
        </Row>
      </Card>
    );
  }
}

TravelInsuranceAdvert1.propTypes = {
  items: PropTypes.string,
};

export default TravelInsuranceAdvert1;
